import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import { base44 } from '@/api/base44Client';

const inputCls = 'w-full bg-[#0d0d0f] border border-white/10 text-white text-sm px-3 py-2 focus:border-primary/60 outline-none';

export default function CrmTaskFormModal({ email, customerName, task, customers = [], onClose, onSaved }) {
  const [form, setForm] = useState({
    customer_email: email || '',
    title: task?.title || '',
    description: task?.description || '',
    due_date: task?.due_date || '',
    priority: task?.priority || 'medium',
    assigned_to: task?.assigned_to || '',
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.customer_email || !form.title) return;
    setSaving(true);
    const cust = customers.find((c) => (c.email || '').toLowerCase() === form.customer_email.toLowerCase());
    const name = cust ? [cust.first_name, cust.last_name].filter(Boolean).join(' ') || cust.full_name : customerName;
    if (task?.id) {
      await base44.entities.CustomerTask.update(task.id, form);
    } else {
      await base44.entities.CustomerTask.create({ ...form, customer_name: name || '', status: 'pending' });
    }
    setSaving(false);
    onSaved?.();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <form onSubmit={submit} className="bg-[#111115] border border-white/10 w-full max-w-md">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
          <p className="text-primary text-[10px] font-bold tracking-widest">{task ? 'EDIT TASK' : 'NEW TASK'}</p>
          <button type="button" onClick={onClose} className="text-white/40 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-5 space-y-4">
          {!email && (
            <div>
              <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">CUSTOMER *</p>
              <select className={inputCls} value={form.customer_email} onChange={(e) => setForm((f) => ({ ...f, customer_email: e.target.value }))} required>
                <option value="" className="bg-[#0d0d0f]">Select a customer…</option>
                {customers.filter((u) => u.role !== 'admin').map((u) => (
                  <option key={u.id} value={u.email} className="bg-[#0d0d0f]">
                    {[u.first_name, u.last_name].filter(Boolean).join(' ') || u.full_name} — {u.email}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div>
            <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">TITLE *</p>
            <input className={inputCls} value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} required />
          </div>
          <div>
            <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">DESCRIPTION</p>
            <textarea rows={2} className={inputCls + ' resize-none'} value={form.description} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">DUE DATE</p>
              <input type="date" className={inputCls} value={form.due_date} onChange={(e) => setForm((f) => ({ ...f, due_date: e.target.value }))} />
            </div>
            <div>
              <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">PRIORITY</p>
              <select className={inputCls} value={form.priority} onChange={(e) => setForm((f) => ({ ...f, priority: e.target.value }))}>
                <option value="low" className="bg-[#0d0d0f]">Low</option>
                <option value="medium" className="bg-[#0d0d0f]">Medium</option>
                <option value="high" className="bg-[#0d0d0f]">High</option>
              </select>
            </div>
          </div>
          <div>
            <p className="text-white/30 text-[10px] font-bold tracking-widest mb-1.5">ASSIGNED TO</p>
            <input className={inputCls} value={form.assigned_to} onChange={(e) => setForm((f) => ({ ...f, assigned_to: e.target.value }))} placeholder="Admin name" />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 border border-white/10 hover:border-white/30 text-white/60 text-xs font-bold tracking-wider py-2.5">CANCEL</button>
            <button type="submit" disabled={saving} className="flex-1 bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-wider py-2.5 disabled:opacity-40 flex items-center justify-center gap-2">
              {saving && <Loader2 className="w-4 h-4 animate-spin" />} {task ? 'SAVE' : 'CREATE'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}